import { render, staticRenderFns } from "./department-dialog.vue?vue&type=template&id=16f9a3c8"
import script from "./department-dialog.vue?vue&type=script&lang=js"
export * from "./department-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports